import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const LOGIN_URL = 'https://admin.timbrarcfdi.com/auth/login'
const URL_DISTRIBUIDOR = 'https://admin.timbrarcfdi.com/Distribuidores'
const URL_CONTRIBUYENTES = 'https://admin.timbrarcfdi.com/Contribuyentes'
const URL_ASIGNACIONES = 'https://admin.timbrarcfdi.com/Asignaciones'
const URL_COTIZACION = 'https://timbrarcfdi.com/cotizacion'
const URL_ESPECIAL = 'https://admin.timbrarcfdi.com/especiales'
const URL_ESPECIAL_TWO = 'https://admin.timbrarcfdi.com/especialesdos'
const URL_COMPRAS = 'https://admin.timbrarcfdi.com/compras'

let store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    distribuidores: [],
    contribuyentes: [],
    compras: [],
    asignaciones: [],
    updated: false,
    token: ''
  },
  mutations: {
    compras (state, data) {
      state.compras = data
    },
    distribuidores (state, data) {
      state.distribuidores = data
    },
    contribuyentes (state, data) {
      state.contribuyentes = data
    },
    asignaciones (state, data) {
      state.asignaciones = data
    },
    authLogout (state, data) {
      state.token = data
    }
  },
  actions: {
    altaDistribuidor (store, data) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.post(URL_DISTRIBUIDOR, data, options)
    },
    obtenerAsignacionesEspeciales (store) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.get(URL_ESPECIAL, options)
    },
    asignacionesEspecialestwo (store, data) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.post(URL_ESPECIAL_TWO, data, options)
    },
    asignacionesEspeciales (store, contribuyente) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.post(URL_ESPECIAL, contribuyente, options)
    },
    asignarTimbres (store, distribuidor) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.put(URL_DISTRIBUIDOR + '/' + distribuidor.Id, distribuidor, options)
    },
    distribuidorExcel (state, distribuidor) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      let type = (typeof distribuidor.Type !== 'undefined') ? distribuidor.Type : 'full'
      return axios.get(URL_DISTRIBUIDOR + '/' + distribuidor.Id + '/excel/' + type, options)
    },
    asignacionesExcel (state, informacion) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.post(URL_ASIGNACIONES + '/excel', {'informacion': informacion}, options)
    },
    actualizarCompra (store, compra) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.post(URL_COMPRAS + '/' + compra.Id, {
        'Id': compra.Id,
        'Factura': compra.factura
      }, options)
    },
    actualizarDistribuidor (store, distribuidor) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.put(URL_DISTRIBUIDOR + '/' + distribuidor.Id, {
        'Id': distribuidor.Id,
        'Nombre': distribuidor.Nombre,
        'Correo': distribuidor.Correo,
        'Estatus': distribuidor.Estatus,
        'Negativo': distribuidor.Negativo,
        'CantidadNegativa': distribuidor.CantidadNegativa,
        'NotificarTotal': distribuidor.NotificarTotal,
        'Contacto': distribuidor.Contacto,
        'Telefono': distribuidor.Telefono,
        'Grupos': distribuidor.Grupos,
        'Ambientes': distribuidor.Ambientes
      }, options)
    },
    fetchDistribuidor (store, id) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.get(URL_DISTRIBUIDOR + '/' + id, options)
    },
    updateCompras (store, data) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.post(URL_COMPRAS, data, options)
    },
    fetchCompras (store) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.get(URL_COMPRAS, options)
    },
    enviarCotizacion (store, data) {
      return axios.post(URL_COTIZACION, data)
    },
    fetchContribuyente (store, id) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.get(URL_CONTRIBUYENTES + '/' + id, options)
    },
    fetchDistribuidores (store) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.get(URL_DISTRIBUIDOR, options)
    },
    fetchContribuyentes (store) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.get(URL_CONTRIBUYENTES, options)
    },
    fetchAsignaciones (store) {
      let options = {headers: {Authorization: 'Bearer ' + store.state.token}}
      return axios.get(URL_ASIGNACIONES, options)
    },
    authLogin (store, credentials) {
      return axios.post(LOGIN_URL, credentials)
    }
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js